import { render, staticRenderFns } from "./add_activity_company.vue?vue&type=template&id=5bb5b142&scoped=true&"
import script from "./add_activity_company.vue?vue&type=script&lang=js&"
export * from "./add_activity_company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb5b142",
  null
  
)

export default component.exports